import React from 'react'

function Rewards() {
  const rewards = [
    { period: 'Pro Kampagne', amount: '0,067€' },
    { period: 'Pro Tag', amount: '0,335€', note: '(5 Kampagnen)' },
    { period: 'Pro Woche', amount: '2,345€', note: '(35 Kampagnen)' },
    { period: 'Pro Monat', amount: '10,05€', note: '(150 Kampagnen)' }
  ]

  const benefits = [
    'Fair und transparent: Belohnungen sind klar ersichtlich',
    'Einfach: Keine komplizierten Prozesse',
    'Flexibel: Kampagnen zu den Slot-Zeiten ansehen',
    'Sicher: Daten werden geschützt',
    'Regelmäßig: 5 tägliche Möglichkeiten, Belohnungen zu erhalten',
    'Schnell: 5 Sekunden pro Kampagne'
  ]

  return (
    <section id="rewards" className="rewards section">
      <div className="container">
        <h2 className="section-title">Belohnungssystem im Detail</h2>
        <div className="rewards-content">
          <div className="rewards-earning">
            <h3 className="rewards-subtitle">Wie viel kann ich verdienen?</h3>
            <div className="rewards-grid">
              {rewards.map((reward, index) => (
                <div key={index} className="reward-card">
                  <div className="reward-amount">{reward.amount}</div>
                  <div className="reward-period">{reward.period}</div>
                  {reward.note && <div className="reward-note">{reward.note}</div>}
                </div>
              ))}
            </div>
          </div>
          <div className="rewards-benefits">
            <h3 className="rewards-subtitle">Wie funktioniert die Auszahlung?</h3>
            <ul className="benefits-list">
              <li>Belohnungen werden sofort gutgeschrieben</li>
              <li>Auszahlung über das Belohnungssystem</li>
              <li>Transparente Übersicht aller Transaktionen</li>
            </ul>
            <h3 className="rewards-subtitle" style={{ marginTop: '2rem' }}>Warum spotx?</h3>
            <ul className="benefits-list">
              {benefits.map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Rewards
